// 假设你有一个方法来检查用户权限
function checkPermission(el, binding) {
  // 拿到用户权限
  const userPermissions = JSON.parse(sessionStorage.getItem('menuTree')).flatMap((outerItem) => {
    return outerItem.children.flatMap((item) => item.children.map((i) => i.path))
  })
  // 从指令绑定中获取所需的权限
  const requiredPermission = binding.value

  // 检查用户是否具有所需权限
  const hasPermission = userPermissions.includes(requiredPermission)
  // 根据权限设置元素的显示或隐藏
  if (hasPermission) {
    el.style.display = '';
  } else {
    el.style.display = 'none'; // 默认为空字符串，表示显示元素
  }
}

// 注册全局自定义指令 v-has-permission

export default function registerGlobalDirectives(Vue) {
  Vue.directive('has-permission', {
    // 当被绑定的元素挂载到 DOM 中时……
    inserted: function (el, binding) {
      // 调用权限检查函数
      checkPermission(el, binding);
    },
    // 当更新带有指令的元素的绑定值时……
    update: function (el, binding) {
      // 根据最新的绑定值再次调用权限检查函数
      checkPermission(el, binding);
    }
  });
}
